<div mat-dialog-title class="dialog-title">
  <div class="view-subtitle">
    <mat-icon *ngIf="registrationRequest.status"
      [class]="getUserStatusIcon(registrationRequest.status)"
      [matTooltip]="getRequestStatusName(registrationRequest.status)"
      matTooltipClass="custom-tooltip"
    ></mat-icon>
    <h2 class="header-request">
      <span>{{ 'registrationRequests.title' | transloco }} <span *ngIf="registrationRequest.requestNumber">№</span></span
      >{{ registrationRequest.requestNumber }} <span *ngIf="registrationRequest.createdAt">от</span>
      {{ registrationRequest.createdAt | date: 'dd.MM.yyyy' }}<br />{{ registrationRequest.surname }}
      {{ registrationRequest.firstname }}
      {{ registrationRequest.patronymic }}
    </h2>
  </div>
  <button class="close-btn ms-auto" (click)="closeDialog()"></button>
</div>

<div class="spinner-wrap">
  <div *ngIf="loading || !isDataInitialized" class="spinner-container">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
</div>
<div *ngIf="!loading && !!registrationRequestError" class="mb-3">
  <p>{{ registrationRequestError }}</p>
</div>

<div *ngIf="!loading && !registrationRequestError && isDataInitialized" class="view-page">
  <div class="form-wrapper zit-scrollbar">
    <div class="title-wrap">
      <div *ngIf="isEditing" class="buttons">
        <button class="secondary" (click)="onEditModeChange(false)">
          <span>{{ 'cancel' | transloco }}</span>
        </button>
        <button class="primary" (click)="onSaveChanges()" [disabled]="isFormInvalid()">
          <span>{{ 'profileStrangers.send' | transloco }}</span>
        </button>
      </div>

      <div class="buttons" *ngIf="!isEditing && registrationRequest.canEditRequest">
        <button class="secondary" (click)="onEditModeChange(true)">
          <span>{{ 'profileStrangers.edit' | transloco }}</span>
        </button>
      </div>
    </div>
    <form #editForm="ngForm">
      <div>
        <div class="form-fields">
          <div class="clients" *ngIf="isEditing">
            <h4 class="col-12">
              {{ 'registrationStrangers.titleCheckboxClients' | transloco }}
              <div class="ms-2 d-inline-block">
                <svg-icon
                  key="question"
                  class="s"
                  matTooltipClass="custom-tooltip"
                  [matTooltip]="'profileStrangers.tooltipRequestCheckboxClients' | transloco"
                ></svg-icon>
              </div>
            </h4>

            <div *ngIf="loadingClients" class="spinner-container">
              <mat-spinner [diameter]="30"></mat-spinner>
            </div>
            <ng-container *ngIf="!loadingClients">
              <mat-checkbox
                *ngFor="let client of editData.clients; let i = index"
                [(ngModel)]="client.checked"
                [attr.data-test]="'profileStrangers_client_checkbox_' + i"
                [name]="'client_checkbox_' + i"
                (change)="onChangeCheckboxClients()"
                disabled="true"
              >
                <span>{{ getActiveLang() === 'ru' ? client.fullName : client.fullNameEn }}</span>
              </mat-checkbox>

              <mat-error *ngIf="isClientsErrorShown && !isClientsSelected()" class="small">
                {{ 'profileStrangers.requiredRequestCheckboxClients' | transloco }}
              </mat-error></ng-container
            >
          </div>
          <!-- Договорились пока не позволять редактировать это поле -->
          <!-- <div class="field-row long" *ngIf="isEditing">
            <mat-label class="label-row">
              <span class="label-text">{{ 'registrationStrangers.type' | transloco }}</span>

              <svg-icon
                key="question"
                class="s ms-2"
                matTooltipClass="custom-tooltip"
                [matTooltip]="'registrationRequests.requesterTypeMessage' | transloco"
              ></svg-icon>
            </mat-label>
            <mat-form-field class="split-view-input">
              <mat-select data-test="registrationStrangers_select-type-user" [(ngModel)]="editData.typeUser" required name="typeUser"  panelClass="split-view-select-panel">
                <mat-option
                  [attr.data-test]="'add-doc-dialog_select-type-user-option-' + i"
                  *ngFor="let type of typesUser; let i = index"
                  [value]="type"
                >
                  <span>{{ getActiveLang() === 'ru' ? type.name : type.inEnglish }}</span>
                </mat-option>
              </mat-select>
              <mat-error *ngIf="editForm?.form?.get('typeUser')?.hasError('required') && editForm?.form?.get('typeUser')?.touched">{{
                'registrationStrangers.typeRequiredError' | transloco
              }}</mat-error>
            </mat-form-field>
          </div> -->

          <div class="field-row long">
            <mat-label class="label-row">
              <span class="label-text">{{ 'registrationStrangers.type' | transloco }}</span>
              <svg-icon
                key="question"
                class="s ms-2"
                matTooltipClass="custom-tooltip"
                [matTooltip]="'registrationRequests.requesterTypeMessage' | transloco"
              ></svg-icon>
            </mat-label>
            <mat-form-field class="split-view-input">
              <input matInput [disabled]="true" [value]="getTypeUserName()" />
            </mat-form-field>
          </div>
        </div>

        <mat-accordion multi>
          <mat-expansion-panel [expanded]="true" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title
                ><mat-icon class="left arrowdown"></mat-icon><b>{{ 'registrationStrangers.personalTitle' | transloco }}</b></mat-panel-title
              >
            </mat-expansion-panel-header>
            <div class="form-fields">
              <div class="field-row">
                <mat-label class="label-row" [ngClass]="{ required: getCanEditPersonalData() }">{{
                  'registrationStrangers.surname' | transloco
                }}</mat-label>
                <mat-form-field class="split-view-input">
                  <input
                    matInput
                    required
                    [minlength]="validationConstants.MIN_NAME_LENGTH"
                    [maxlength]="validationConstants.MAX_NAME_LENGTH"
                    [pattern]="regexPatterns.NAME_PATTERN"
                    [(ngModel)]="editData.personalData.surname"
                    name="surname"
                    *ngIf="getCanEditPersonalData(); else viewSurname"
                  />
                  <ng-template #viewSurname>
                    <input matInput [disabled]="true" [value]="registrationRequest.surname" />
                  </ng-template>
                  <mat-error *ngIf="editForm?.form?.get('surname')?.hasError('required') && editForm?.form?.get('surname')?.touched">
                    {{ 'registrationStrangers.typeRequiredError' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('surname')?.hasError('minlength') && editForm?.form?.get('surname')?.touched">
                    {{ 'registrationStrangers.errorTooShort' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('surname')?.hasError('maxlength') && editForm?.form?.get('surname')?.touched">
                    {{ 'registrationStrangers.errorMaxLength60' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('surname')?.hasError('pattern') && editForm?.form?.get('surname')?.touched">
                    {{ 'registrationStrangers.errorInvalidCharacters' | transloco }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="field-row">
                <mat-label class="label-row" [ngClass]="{ required: getCanEditPersonalData() }">{{
                  'registrationStrangers.name' | transloco
                }}</mat-label>
                <mat-form-field class="split-view-input">
                  <input
                    matInput
                    required
                    [minlength]="validationConstants.MIN_NAME_LENGTH"
                    [maxlength]="validationConstants.MAX_NAME_LENGTH"
                    [pattern]="regexPatterns.NAME_PATTERN"
                    [(ngModel)]="editData.personalData.firstname"
                    name="firstname"
                    *ngIf="getCanEditPersonalData(); else viewFirstName"
                  />
                  <ng-template #viewFirstName>
                    <input matInput [disabled]="true" [value]="registrationRequest.firstname" />
                  </ng-template>
                  <mat-error *ngIf="editForm?.form?.get('firstname')?.hasError('required') && editForm?.form?.get('firstname')?.touched">
                    {{ 'registrationStrangers.typeRequiredError' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('firstname')?.hasError('minlength') && editForm?.form?.get('firstname')?.touched">
                    {{ 'registrationStrangers.errorTooShort' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('firstname')?.hasError('maxlength') && editForm?.form?.get('firstname')?.touched">
                    {{ 'registrationStrangers.errorMaxLength60' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('firstname')?.hasError('pattern') && editForm?.form?.get('firstname')?.touched">
                    {{ 'registrationStrangers.errorInvalidCharacters' | transloco }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="field-row">
                <mat-label class="label-row">{{ 'registrationStrangers.patronymic' | transloco }}</mat-label>
                <mat-form-field class="split-view-input">
                  <input
                    matInput
                    [minlength]="validationConstants.MIN_NAME_LENGTH"
                    [maxlength]="validationConstants.MAX_NAME_LENGTH"
                    [pattern]="regexPatterns.NAME_PATTERN"
                    [(ngModel)]="editData.personalData.patronymic"
                    name="patronymic"
                    *ngIf="getCanEditPersonalData(); else viewPatronymic"
                  />
                  <ng-template #viewPatronymic>
                    <input matInput [disabled]="true" [value]="registrationRequest.patronymic" />
                  </ng-template>
                  <mat-error *ngIf="editForm?.form?.get('patronymic')?.hasError('minlength') && editForm?.form?.get('patronymic')?.touched">
                    {{ 'registrationStrangers.errorTooShort' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('patronymic')?.hasError('maxlength') && editForm?.form?.get('patronymic')?.touched">
                    {{ 'registrationStrangers.errorMaxLength60' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('patronymic')?.hasError('pattern') && editForm?.form?.get('patronymic')?.touched">
                    {{ 'registrationStrangers.errorInvalidCharacters' | transloco }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="field-row">
                <mat-label class="label-row" [ngClass]="{ required: getCanEditPersonalData() }">{{
                  'registrationStrangers.taxNumber' | transloco
                }}</mat-label>
                <mat-form-field class="split-view-input">
                  <input
                    matInput
                    required
                    [minlength]="validationConstants.MIN_NAME_LENGTH"
                    [maxlength]="validationConstants.MAX_INN_LENGTH"
                    [pattern]="regexPatterns.INN_PATTERN"
                    [(ngModel)]="editData.personalData.inn"
                    name="inn"
                    *ngIf="getCanEditPersonalData() && isEditing; else viewInn"
                  />
                  <ng-template #viewInn>
                    <input matInput [disabled]="true" [value]="registrationRequest.inn" />
                  </ng-template>
                  <mat-error *ngIf="editForm?.form?.get('inn')?.hasError('required') && editForm?.form?.get('inn')?.touched">
                    {{ 'registrationStrangers.typeRequiredError' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('inn')?.hasError('minlength') && editForm?.form?.get('inn')?.touched">
                    {{ 'registrationStrangers.errorTooShort' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('inn')?.hasError('maxlength') && editForm?.form?.get('inn')?.touched">
                    {{ 'registrationStrangers.errorMaxLength50' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('inn')?.hasError('pattern') && editForm?.form?.get('inn')?.touched">
                    {{ 'registrationStrangers.errorInvalidCharacters' | transloco }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="field-row long">
                <mat-label class="label-row" [ngClass]="{ required: getCanEditPersonalData() }">{{
                  'registrationStrangers.country' | transloco
                }}</mat-label>
                <mat-form-field class="split-view-input" *ngIf="getCanEditPersonalData(); else viewCountry">
                  <mat-select
                    [(ngModel)]="editData.personalData.countryId"
                    name="countryId"
                    required
                    (selectionChange)="onCountryChange('personal', $event.value)"
                    (opened)="personalCountryId.focus()"
                    panelClass="split-view-select-panel"
                  >
                    <mat-form-field appearance="standard" class="country-search-input">
                      <input
                        matInput
                        #personalCountryId
                        type="text"
                        (keydown)="$event.stopPropagation()"
                        placeholder="{{ 'registrationStrangers.search' | transloco }}"
                      />
                    </mat-form-field>
                    <mat-option *ngFor="let country of getCountriesList(countriesAll, personalCountryId.value)" [value]="getCountryIdString(country)">
                      {{ getActiveLang() === 'ru' ? country.name : country.inEnglish }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="editForm?.form?.get('countryId')?.hasError('required') && editForm?.form?.get('countryId')?.touched">
                    {{ 'registrationStrangers.typeRequiredError' | transloco }}
                  </mat-error>
                </mat-form-field>
                <ng-template #viewCountry>
                  <mat-form-field class="split-view-input">
                    <input matInput [disabled]="true" [value]="getCountryDisplayName('personal')" />
                  </mat-form-field>
                </ng-template>
              </div>

              <div class="field-row long">
                <mat-label class="label-row" [ngClass]="{ required: getCanEditPersonalData() }">{{
                  'registrationStrangers.addressTitle' | transloco
                }}</mat-label>
                <mat-form-field class="input split-view-input">
                  <input
                    matInput
                    required
                    [minlength]="validationConstants.MIN_ADDRESS_LENGTH"
                    [maxlength]="validationConstants.MAX_ADDRESS_LENGTH"
                    [pattern]="regexPatterns.ADDRESS_PATTERN"
                    [(ngModel)]="editData.personalData.address"
                    name="address"
                    *ngIf="getCanEditPersonalData(); else viewAddress"
                  />
                  <ng-template #viewAddress>
                    <input matInput [disabled]="true" [value]="getAddress" />
                  </ng-template>
                  <mat-error *ngIf="editForm?.form?.get('address')?.hasError('required') && editForm?.form?.get('address')?.touched">
                    {{ 'registrationStrangers.typeRequiredError' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('address')?.hasError('minlength') && editForm?.form?.get('address')?.touched">
                    {{ 'registrationStrangers.errorTooShort' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('address')?.hasError('maxlength') && editForm?.form?.get('address')?.touched">
                    {{ 'registrationStrangers.errorMaxLength255' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('address')?.hasError('pattern') && editForm?.form?.get('address')?.touched">
                    {{ 'registrationStrangers.errorInvalidCharacters' | transloco }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel *ngIf="showOrganizationBlock" [expanded]="true" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title
                ><mat-icon class="left arrowdown"></mat-icon><b>{{ 'registrationStrangers.titleOrganization' | transloco }}</b></mat-panel-title
              >
            </mat-expansion-panel-header>
            <div class="form-fields">
              <div class="field-row long">
                <mat-label class="label-row" [ngClass]="{ required: getCanEditOrganizationData() }">{{
                  'registrationStrangers.orgForm' | transloco
                }}</mat-label>
                <mat-form-field class="split-view-input">
                  <input
                    matInput
                    required
                    [minlength]="validationConstants.MIN_NAME_LENGTH"
                    [maxlength]="validationConstants.MAX_ORGANIZATION_NAME_LENGTH"
                    [pattern]="regexPatterns.OLF_PATTERN"
                    [(ngModel)]="editData.organizationData.olf"
                    name="olf"
                    *ngIf="getCanEditOrganizationData(); else viewOrgForm"
                  />
                  <ng-template #viewOrgForm>
                    <input matInput [disabled]="true" [value]="registrationRequest.orgOlf" />
                  </ng-template>
                  <mat-error *ngIf="editForm?.form?.get('olf')?.hasError('required') && editForm?.form?.get('olf')?.touched">
                    {{ 'registrationStrangers.typeRequiredError' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('olf')?.hasError('minlength') && editForm?.form?.get('olf')?.touched">
                    {{ 'registrationStrangers.errorTooShort' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('olf')?.hasError('maxlength') && editForm?.form?.get('olf')?.touched">
                    {{ 'registrationStrangers.errorMaxLength255' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('olf')?.hasError('pattern') && editForm?.form?.get('olf')?.touched">
                    {{ 'registrationStrangers.errorInvalidCharacters' | transloco }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="field-row long">
                <mat-label class="label-row" [ngClass]="{ required: getCanEditOrganizationData() }">{{
                  'registrationRequests.orgName' | transloco
                }}</mat-label>
                <mat-form-field class="input split-view-input">
                  <input
                    matInput
                    required
                    [minlength]="validationConstants.MIN_NAME_LENGTH"
                    [maxlength]="validationConstants.MAX_ORGANIZATION_NAME_LENGTH"
                    [pattern]="regexPatterns.ORGANIZATION_NAME_PATTERN"
                    [(ngModel)]="editData.organizationData.fullName"
                    name="fullName"
                    *ngIf="getCanEditOrganizationData(); else viewOrgName"
                  />
                  <ng-template #viewOrgName>
                    <input matInput [disabled]="true" [value]="getRegistrationRequestName" />
                  </ng-template>
                  <mat-error *ngIf="editForm?.form?.get('fullName')?.hasError('required') && editForm?.form?.get('fullName')?.touched">
                    {{ 'registrationStrangers.typeRequiredError' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('fullName')?.hasError('minlength') && editForm?.form?.get('fullName')?.touched">
                    {{ 'registrationStrangers.errorTooShort' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('fullName')?.hasError('maxlength') && editForm?.form?.get('fullName')?.touched">
                    {{ 'registrationStrangers.errorMaxLength255' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('fullName')?.hasError('pattern') && editForm?.form?.get('fullName')?.touched">
                    {{ 'registrationStrangers.errorInvalidCharacters' | transloco }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div *ngIf="isOrganization" class="field-row">
                <mat-label class="label-row">{{ 'registrationRequests.orgShortName' | transloco }}</mat-label>
                <mat-form-field class="input split-view-input">
                  <input
                    matInput
                    [minlength]="validationConstants.MIN_NAME_LENGTH"
                    [maxlength]="validationConstants.MAX_ORGANIZATION_NAME_LENGTH"
                    [pattern]="regexPatterns.ORGANIZATION_NAME_PATTERN"
                    [(ngModel)]="editData.organizationData.shortName"
                    name="shortName"
                    *ngIf="getCanEditOrganizationData(); else viewOrgShortName"
                  />
                  <ng-template #viewOrgShortName>
                    <input matInput [disabled]="true" [value]="registrationRequest.orgShortname" />
                  </ng-template>
                  <mat-error *ngIf="editForm?.form?.get('shortName')?.hasError('required') && editForm?.form?.get('shortName')?.touched">
                    {{ 'registrationStrangers.typeRequiredError' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('shortName')?.hasError('minlength') && editForm?.form?.get('shortName')?.touched">
                    {{ 'registrationStrangers.errorTooShort' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('shortName')?.hasError('maxlength') && editForm?.form?.get('shortName')?.touched">
                    {{ 'registrationStrangers.errorMaxLength255' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('shortName')?.hasError('pattern') && editForm?.form?.get('shortName')?.touched">
                    {{ 'registrationStrangers.errorInvalidCharacters' | transloco }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="field-row">
                <mat-label class="label-row" [ngClass]="{ required: getCanEditOrganizationData() }">{{
                  'registrationStrangers.taxNumberOrganization' | transloco
                }}</mat-label>
                <!-- Договорились пока не позволять редактировать это поле -->
                <!-- <mat-form-field class="split-view-input">
                  <input
                    matInput
                    required
                    [minlength]="validationConstants.MIN_NAME_LENGTH"
                    [maxlength]="validationConstants.MAX_ORG_INN_LENGTH"
                    [pattern]="regexPatterns.INN_PATTERN"
                    [(ngModel)]="editData.organizationData.inn"
                    name="orgInn"
                    *ngIf="getCanEditOrganizationData(); else viewOrgInn"
                  />
                  <ng-template #viewOrgInn>
                    <input matInput [disabled]="true" [value]="registrationRequest.orgInn" />
                  </ng-template>
                  <mat-error *ngIf="editForm?.form?.get('orgInn')?.hasError('required') && editForm?.form?.get('orgInn')?.touched">
                    {{ 'registrationStrangers.typeRequiredError' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('orgInn')?.hasError('minlength') && editForm?.form?.get('orgInn')?.touched">
                    {{ 'registrationStrangers.errorTooShort' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('orgInn')?.hasError('maxlength') && editForm?.form?.get('orgInn')?.touched">
                    {{ 'registrationStrangers.errorMaxLength20' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('orgInn')?.hasError('pattern') && editForm?.form?.get('orgInn')?.touched">
                    {{ 'registrationStrangers.errorInvalidCharacters' | transloco }}
                  </mat-error>
                </mat-form-field> -->
                <mat-form-field class="split-view-input"> <input matInput [disabled]="true" [value]="registrationRequest.orgInn" /> </mat-form-field>
              </div>

              <div class="field-row">
                <mat-label class="label-row" [ngClass]="{ required: getCanEditOrganizationData() }">
                  {{ 'registrationStrangers.organizationEmail' | transloco }}
                </mat-label>
                <mat-form-field class="split-view-input">
                  <input
                    matInput
                    required
                    [minlength]="validationConstants.MIN_EMAIL_LENGTH"
                    [maxlength]="validationConstants.MAX_EMAIL_LENGTH"
                    [pattern]="regexPatterns.EMAIL_PATTERN"
                    [(ngModel)]="editData.organizationData.email"
                    name="orgEmail"
                    *ngIf="getCanEditOrganizationData(); else viewOrgEmail"
                  />
                  <ng-template #viewOrgEmail>
                    <input matInput [disabled]="true" [value]="registrationRequest.orgEmail" />
                  </ng-template>
                  <mat-error *ngIf="editForm?.form?.get('orgEmail')?.hasError('required') && editForm?.form?.get('orgEmail')?.touched">
                    {{ 'registrationStrangers.typeRequiredError' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('orgEmail')?.hasError('minlength') && editForm?.form?.get('orgEmail')?.touched">
                    {{ 'registrationStrangers.errorTooShort' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('orgEmail')?.hasError('maxlength') && editForm?.form?.get('orgEmail')?.touched">
                    {{ 'registrationStrangers.errorMaxLength64' | transloco }}
                  </mat-error>
                  <mat-error
                    *ngIf="
                      editForm?.form?.get('orgEmail')?.hasError('pattern') &&
                      editForm?.form?.get('orgEmail')?.touched
                    "
                  >
                    {{ 'registrationStrangers.errorEmailInvalid' | transloco }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="field-row">
                <mat-label class="label-row" [ngClass]="{ required: getCanEditOrganizationData() }">{{
                  'registrationStrangers.organizationPhone' | transloco
                }}</mat-label>
                <app-phone-custom
                  *ngIf="editData.phoneOrganization?.phoneCountryCode"
                  [ngModel]="editData.phoneOrganization"
                  (ngModelChange)="onPhoneOrganizationChange($event)"
                  (phoneChange)="onChangedOrganizationPhone($event)"
                  [required]="true"
                  [allCountries]="countriesAll"
                  class="split-view-input"
                  placeholder="{{ 'registrationStrangers.phoneNumber' | transloco }} *"
                  placeholderSearch="{{ 'registrationStrangers.search' | transloco }}"
                  errorRequired="{{ 'registrationStrangers.typeRequiredError' | transloco }}"
                  data-test="profileStrangers_organization-custom-phone"
                  name="o_phone"
                  [disabled]="!getCanEditOrganizationData()"
                  [maxLength]="ValidationConstants.MAX_PHONE_LENGTH"
                  [minLength]="ValidationConstants.MIN_PHONE_LENGTH"
                >
                </app-phone-custom>
              </div>

              <div class="field-row long">
                <mat-label class="label-row" [ngClass]="{ required: getCanEditOrganizationData() }">{{
                  'registrationStrangers.countryRrgistry' | transloco
                }}</mat-label>
                <!-- Договорились пока не позволять редактировать это поле -->
                <!-- <mat-form-field class="split-view-input" *ngIf="getCanEditOrganizationData(); else viewOrgCountry">
                  <mat-select
                    [(ngModel)]="editData.organizationData.countryId"
                    name="orgCountryId"
                    required
                    (selectionChange)="onCountryChange('organization', $event.value)"
                     panelClass="split-view-select-panel"
                  >
                  <mat-form-field appearance="standard" class="country-search-input">
                      <input
                        matInput
                        #personalCountryId
                        type="text"
                        (keydown)="$event.stopPropagation()"
                        placeholder="{{ 'registrationStrangers.search' | transloco }}"
                      />
                    </mat-form-field>
                    <mat-option *ngFor="let country of getCountriesList(countriesByClients, personalCountryId.value)" [value]="getCountryIdString(country)">
                      {{ getActiveLang() === 'ru' ? country.name : country.inEnglish }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="editForm?.form?.get('orgCountryId')?.hasError('required') && editForm?.form?.get('orgCountryId')?.touched">
                    {{ 'registrationStrangers.typeRequiredError' | transloco }}
                  </mat-error>
                </mat-form-field>
                <ng-template #viewOrgCountry>
                  <mat-form-field class="split-view-input">
                    <input matInput [disabled]="true" [value]="getCountryDisplayName('organization')" />
                  </mat-form-field>
                </ng-template> -->
                <mat-form-field class="split-view-input">
                  <input matInput [disabled]="true" [value]="getCountryDisplayName('organization')" />
                </mat-form-field>
              </div>

              <div class="field-row long">
                <mat-label class="label-row" [ngClass]="{ required: getCanEditOrganizationData() }">{{
                  'registrationStrangers.organizationAddress' | transloco
                }}</mat-label>
                <mat-form-field class="input split-view-input">
                  <input
                    matInput
                    required
                    [minlength]="validationConstants.MIN_ADDRESS_LENGTH"
                    [maxlength]="validationConstants.MAX_ADDRESS_LENGTH"
                    [pattern]="regexPatterns.ORGANIZATION_ADDRESS_PATTERN"
                    [(ngModel)]="editData.organizationData.address"
                    name="orgAddress"
                    *ngIf="getCanEditOrganizationData(); else viewOrgAddress"
                  />
                  <ng-template #viewOrgAddress>
                    <input matInput [disabled]="true" [value]="registrationRequest.orgAddress" />
                  </ng-template>
                  <mat-error *ngIf="editForm?.form?.get('orgAddress')?.hasError('required') && editForm?.form?.get('orgAddress')?.touched">
                    {{ 'registrationStrangers.typeRequiredError' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('orgAddress')?.hasError('minlength') && editForm?.form?.get('orgAddress')?.touched">
                    {{ 'registrationStrangers.errorTooShort' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('orgAddress')?.hasError('maxlength') && editForm?.form?.get('orgAddress')?.touched">
                    {{ 'registrationStrangers.errorMaxLength255' | transloco }}
                  </mat-error>
                  <mat-error *ngIf="editForm?.form?.get('orgAddress')?.hasError('pattern') && editForm?.form?.get('orgAddress')?.touched">
                    {{ 'registrationStrangers.errorInvalidCharacters' | transloco }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true" hideToggle *ngIf="!isEditing">
            <mat-expansion-panel-header>
              <mat-panel-title
                ><mat-icon class="left arrowdown"></mat-icon><b>{{ 'registrationStrangers.journal' | transloco }}</b></mat-panel-title
              >
            </mat-expansion-panel-header>

            <div *ngIf="loadingRequestHistory" class="spinner-container">
              <mat-spinner [diameter]="30"></mat-spinner>
            </div>

            <app-registrations-history-table
              *ngIf="!loadingRequestHistory && !isEmptyList"
              #listTable
              [tableData]="{ hasNextPage: false, payload: registrationRequestHistory, errorMessage: '' }"
            ></app-registrations-history-table>

            <div *ngIf="!loadingRequestHistory && isEmptyList" class="info-wrapper">
              <app-table-data-request-error [errorStatus]="registrationRequestHistoryErrorStatus"></app-table-data-request-error>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </form>
  </div>
</div>
